import { useEffect } from "react";
import { Check, AlertTriangle, Sparkles } from './icons';
export const Toast = ({ msg, type = "info", c, onClose }) => {
  useEffect(() => { const t = setTimeout(onClose, 3000); return () => clearTimeout(t); }, [onClose]);
  const bg = type === "success" ? c.green : type === "error" ? c.red : c.blue;
  return (
    <div style={{
      position: "fixed", bottom: 24, right: 24, zIndex: 200,
      padding: "12px 20px", borderRadius: 12, color: "#fff",
      background: bg, fontSize: 13, fontWeight: 600,
      boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
      animation: "fadeSlideUp 0.3s cubic-bezier(0.25,0.1,0.25,1) both",
      display: "flex", alignItems: "center", gap: 8,
    }}>
      {type === "success" ? <Check size={14} /> : type === "error" ? <AlertTriangle size={14} /> : <Sparkles size={14} />}
      {msg}
    </div>
  );
};
